module.exports = __webpack_public_path__ + "static/media/useCase43x.d1996113.png";